import {
  FsAltSeasonPointRules,
  FsSeasonPointsRules,
  FsSeasonPointsRulesBase,
  isFsPositionSeasonPointsRules,
} from "db/model/tournament/Segment/Season/FsSeasonPointRules";
import {
  AltSeasonPointsRules,
  isBonusType,
  isSeasonPoints,
  SeasonPointsRules,
  SeasonPointsRulesBase,
} from "model/Tournament/Segment/Season/SeasonPointRules";
import { nonUndefined } from "Utility";

const mapSeasonPointsRulesBase = (
  fsModel: FsSeasonPointsRulesBase
): SeasonPointsRulesBase => {
  return {
    dqPoints: fsModel.dqPoints,
    finalistPoints: fsModel.finalistPoints,
    ffPoints: fsModel.ffPoints,
    bonus: isBonusType(fsModel.bonusType)
      ? {
          amount: fsModel.bonusAmount,
          dqAmount: fsModel.dqBonusAmount,
          ffAmount: fsModel.ffBonusAmount,
          type: fsModel.bonusType,
        }
      : undefined,
  };
};

export const mapSeasonPointsRules = (
  fsModel: FsSeasonPointsRules
): SeasonPointsRules => {
  if (isFsPositionSeasonPointsRules(fsModel)) {
    return {
      ...mapSeasonPointsRulesBase(fsModel),
      position: !!fsModel.position
        ? fsModel.position.map((p) => (isSeasonPoints(p) ? p : 0))
        : [1, 0],
    };
  }

  return {
    ...mapSeasonPointsRulesBase(fsModel),
    win: fsModel.win ?? 1,
    draw: fsModel.draw ?? 0,
    loss: fsModel.loss ?? 0,
  };
};

export const mapAltSeasonPointsRules = (
  fsModels: FsAltSeasonPointRules[]
): AltSeasonPointsRules[] => {
  return nonUndefined(
    fsModels.map((a) => {
      if (!a.matchIds || !a.points) {
        return undefined;
      }

      return {
        matchIds: a.matchIds,
        points: mapSeasonPointsRules(a.points),
      };
    })
  );
};
